import { CATEGORIES } from '../data/complianceData';

export const getRequirementLevelColor = (requirement: string): string => {
  if (requirement.includes('BASIC:')) return 'cs-badge cs-badge-green';
  if (requirement.includes('IMPORTANT:')) return 'cs-badge cs-badge-yellow';
  if (requirement.includes('ESSENTIAL:')) return 'cs-badge cs-badge-red';
  return 'cs-badge cs-badge-gray';
};

export const getComplianceStatusColor = (status: string): string => {
  switch (status) {
    case 'completed': return 'text-green-600 bg-green-50';
    case 'in-progress': return 'text-yellow-600 bg-yellow-50';
    default: return 'text-gray-400 bg-gray-50';
  }
};

export const getItemCategory = (itemId: string): string => {
  for (const [cat, ids] of Object.entries(CATEGORIES)) {
    if (ids.includes(itemId)) return cat;
  }
  return 'Other';
};
